import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ roles }) => {
  const { user } = useSelector((state) => state.user);
  const { isAuthenticated, role } = user;
  if (!isAuthenticated)
    return (
      <Navigate
        to={roles.includes("admin") ? "/admin/login" : "/login"}
        replace
      />
    );

  if (!roles.includes(role)) {
    return <Navigate to={role === "user" ? "/" : "/admin/dashboard"} replace />;
  }

  return <Outlet />;
};

export const PublicRoute = () => {
  const { state } = useLocation();
  const { user } = useSelector((state) => state.user);
  const { isAuthenticated, role } = user;
  if (isAuthenticated)
    return (
      <Navigate
        to={role === "user" ? state?.from ?? "/" : "/admin/dashboard"}
        replace
      />
    );

  return <Outlet />;
};
